<template>
  <div>
    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between">
      <!-- 搜索 -->
      <div>
        <el-select
          v-model="departmentId"
          placeholder="请选择部门"
          style="width: 200px"
          size="mini"
          clearable
          @clear="search"
        >
          <el-option
            v-for="item in departments"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>

        <!-- 费用日期区间筛选（与项目管理各录入页面保持一致） -->
        <el-date-picker
          v-model="rqScope"
          style="margin-left: 10px"
          size="mini"
          type="daterange"
          value-format="yyyy-MM-dd"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          clearable
          @change="onDateChange"
        >
        </el-date-picker>

        <el-button
          type="primary"
          icon="el-icon-search"
          @click="search"
          size="small"
          style="margin-left: 20px"
          >搜索</el-button
        >
      </div>
      <!-- 右边工具 -->
      <div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="showAddView"
          size="small"
          v-if="qx"
          >添加收款</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <div style="margin-top: 20px">
      <el-table
        :data="incomeData"
        stripe
        border
        :row-style="{ height: '59px' }"
        height="calc(100vh - 280px)"
        :cell-style="{ padding: '5px 0' }"
        size="small"
        fit
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="width: 100%"
      >
        <!-- 多选框 -->
        <!-- <el-table-column type="selection" align="center" width="55"></el-table-column> -->
        <el-table-column
          prop="departmentId"
          label="部门ID"
          fixed
          align="center"
          width="90"
        >
        </el-table-column>
        <el-table-column
          prop="departmentName"
          label="部门名称"
          fixed
          align="center"
        >
        </el-table-column>
        <el-table-column prop="rq" label="费用日期" align="center" width="120">
        </el-table-column>
        <!-- <el-table-column prop="costName" label="费用名称"  align="center">
				</el-table-column> -->
        <el-table-column label="收款金额" align="center" width="150">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.income) }}元</span>
          </template>
        </el-table-column>
        <el-table-column prop="bz" label="摘要" align="center">
        </el-table-column>
        <el-table-column
          prop="userName"
          label="录入人员"
          sortable
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="checkUserName"
          label="复核人员"
          sortable
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.isCheck === '1' ? scope.row.checkUserName : '--' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建日期"
          align="center"
        
        width="120"
        
        :formatter="dateTimeTwoLine"
        class-name="cell-two-line"
        >
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="修改日期"
          align="center"
        
        width="120"
        
        :formatter="dateTimeTwoLine"
        class-name="cell-two-line"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="270"
          v-if="qx"
        >
          <template slot-scope="scope">

            <template v-if="userId != scope.row.userId">
              <el-button type="primary" size="mini" v-if="scope.row.isCheck === '0'" @click="reCheck(scope.row.id, 1)">
                复核
              </el-button>
              <el-button type="warning" size="mini" v-else @click="reCheck(scope.row.id, 0)">
                撤销复核
              </el-button>
            </template>

            <el-button
              type="primary"
              size="mini"
              @click="showEditView(scope.row)"
              :disabled="kaiguan(scope.row.createTime) || scope.row.isCheck === '1'"
              >编辑</el-button
            >
            <el-button
              type="danger"
              @click="deleteRecord(scope.row)"
              size="mini"
              :disabled="kaiguan(scope.row.createTime) || scope.row.isCheck === '1'"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div style="display: flex; justify-content: flex-end; margin-top: 5px">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="total"
          :current-page="page">
        </el-pagination>
      </div>
    </div>
    <!-- 弹出框  dialogVisible:是否弹出 添加或编辑-->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="70%"       :close-on-click-modal="false"
      :close-on-press-escape="false"
>
      <div>
        <!-- 增加一层 el-form表单，可以数据校验 -->
        <el-form ref="inputForm" :model="inputObj" :rules="rules">
          <el-row>
            <el-col :span="12">
              <el-form-item label="部门名称" prop="departmentId">
                <el-select
                  v-model="inputObj.departmentId"
                  placeholder="请选择"
                  size="mini"
                  :disabled="xmShow"
                  style="width: 250px"
                >
                  <el-option
                    v-for="item in departments"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="收款日期" prop="rq">
                <el-date-picker
                  size="mini"
                  v-model="inputObj.rq"
                  style="width: 250px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="收款金额" prop="income">
                <el-input
                  type="number"
                  size="mini"
                  prefix-icon="el-icon-edit"
                  style="width: 250px"
                  v-model="inputObj.income"
                  placeholder="请输入金额,单位(元)"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="备注信息" prop="bz">
                <el-input
                  type="text"
                  size="mini"
                  prefix-icon="el-icon-edit"
                  style="width: 400px"
                  v-model="inputObj.bz"
                  placeholder="请输入备注信息"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doChance">取 消</el-button>
        <el-button type="primary" @click="doAddRecord">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { kz90 } from "../../utils/MyFunction"; 

export default {
  name: "DepaList",
  data() {
    return {
      qx: true, // 总经理、销售总监编辑的权限
      title: "",
      xmShow: false,
      incomeData: [], // 存放查询结果
      loading: false,
      total: 0,
      page: 1,
      limit: 10,
      departmentId: null,
      rqScope: [], // 费用日期区间（绑定日期控件，提交时拆成 rqBegin/rqEnd）
      queryRqBegin: "", // 查询用：费用日期起
      queryRqEnd: "", // 查询用：费用日期止
      dialogVisible: false,
      // 新增收款对象
      inputObj: {
        id: null,
        departmentId: null,
        rq: "",
        income: null,
        bz: null,
      },
      departments: [], //部门id-部门名称下拉框
      rules: {
        departmentId: [
          {
            required: true,
            message: "请选择部门名称",
            trigger: "blur",
          },
        ],
        rq: [
          {
            required: true,
            message: "请选择收款日期",
            trigger: "blur",
          },
        ],
        bz: [
          {
            required: true,
            message: "请输入摘要",
            trigger: "blur",
          },
        ],
        income: [
          {
            required: true,
            message: "请输入收款金额",
            trigger: "blur",
          },
        ],
      },
      userId: sessionStorage.getItem('uid')
    };
  },
  mounted() {
    this.quanxian();
    this.initIncome();
    this.initDim();
  },
  methods: {
    // 复核操作
    reCheck(id, isCheck){
      let tipText = (isCheck === 1 ? '是否复核此条录入信息?': '是否撤销复核?');
      this.$confirm(tipText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.postRequest2('/depa/income_check',{ id, isCheck }).then(res => {
          if(res.code === 200){
            this.initIncome();
          }
        })
        
      })
    },
    moneyNumber(val) {
      return val.toLocaleString("zh-Hans-CN", {
        style: "currency",
        currency: "CNY",
      });
      // return val.toLocaleString()
    },
    quanxian() {
      if (!window.sessionStorage.getItem("userRoleId")) {
        //权限为空
        // 暂时不做处理，本来应该直接退出
      } else {
        if (window.sessionStorage.getItem("userRoleId") == 8) {
          this.qx = false;
        }
        if (window.sessionStorage.getItem("userRoleId") == 17) {
          this.qx = false;
        }
      }
    },
    kaiguan(sj) {
      var sf = kz90(sj);
      return sf;
    },
    doChance() {
      this.dialogVisible = false;
      this.initIncome();
    },
    showEditView(data) {
      this.title = "编辑费用";
      this.dialogVisible = true;
      this.xmShow = true;
      this.inputObj = data;
    },
    deleteRecord(data) {
      // alert(JSON.stringify(data))
      this.$confirm(
        "此操作将永久删除 " + data.departmentName + "的该条费用明细, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.postRequest2("/depa/income_delete?id=" + data.id).then(
            (resp) => {
              if (resp) {
                this.initIncome();
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    doAddRecord() {
      // 添加 或 编辑
      if (this.inputObj.id) {
        // 编辑修改
        // alert(JSON.stringify(this.inputObj))
        this.$refs["inputForm"].validate((valid) => {
          if (valid) {
            //验证通过
            this.postRequest2("/depa/income_update", this.inputObj).then(
              (resp) => {
                if (resp) {
                  this.dialogVisible = false;
                  this.initIncome();
                }
              }
            );
          }
        });
      } else {
        // 添加
        this.$refs["inputForm"].validate((valid) => {
          if (valid) {
            //验证通过
            this.postRequest2("/depa/income_add", this.inputObj).then(
              (resp) => {
                if (resp) {
                  this.dialogVisible = false;
                  this.initIncome();
                }
              }
            );
          }
        });
      }
      // this.dialogVisible = false
    },
    initDim() {
      if (!window.sessionStorage.getItem("departments")) {
        this.postRequest("/dim/dim_table_char/department").then((resp) => {
          if (resp) {
            this.departments = resp.result;
            this.saveDictCache("departments", resp.result);
          }
        });
      } else {
        this.departments = this.dictCache("departments");
      }
    },
    currentChange(currentPage) {
      this.page = currentPage;
      this.initIncome(true);
    },
    sizeChange(limit) {
      this.limit = limit;
      this.page = 1;
      this.initIncome(true);
    },
    // 条件查询：回到第 1 页再查，避免停留在超出结果范围的页码上
    search() {
      this.page = 1;
      this.initIncome(true);
    },
    // 费用日期区间变化：拆成起止日期后查询
    onDateChange(val) {
      if (val && val.length === 2) {
        this.queryRqBegin = val[0];
        this.queryRqEnd = val[1];
      } else {
        this.queryRqBegin = "";
        this.queryRqEnd = "";
      }
      this.search();
    },
    showAddView() {
      this.title = "添加收款";
      this.dialogVisible = true;
      this.xmShow = false;
      this.inputObj = {
        id: null,
        departmentId: null,
        rq: "",
        income: null,
      };
    },
    initIncome(tj) {
      var url = "/depa/income_list?page=" + this.page + "&limit=" + this.limit;
      // 条件查询（部门 / 费用日期区间）
      if (tj) {
        if (this.departmentId) url += "&departmentId=" + this.departmentId;
        if (this.queryRqBegin) url += "&rqBegin=" + this.queryRqBegin;
        if (this.queryRqEnd) url += "&rqEnd=" + this.queryRqEnd;
      }
      this.loading = true;
      this.getRequest(url).then((resp) => {
        this.loading = false;
        if (resp) {
          this.incomeData = resp.data;
          this.total = resp.count;
        }
      });
    },
  },
};
</script>

<style>
</style>
